import { MIN_PASSWORD_LENGTH, validatePasswordStrength, validatePhone } from 'shared';
import { ApiConflictError, ApiRequestError } from '@/lib/api';

// The API answers in English. What a person reads is said here, in Portuguese,
// and what the API wrote never reaches the page.

export const PASSWORD_RULES = `Pelo menos ${MIN_PASSWORD_LENGTH} caracteres, com uma maiúscula, uma minúscula e um número.`;

export interface RegisterForm {
  name: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
}

/**
 * What is wrong with the form, or null when it can be sent. One thing at a
 * time, in the order of the fields.
 */
export function registerFormError(form: RegisterForm): string | null {
  if (form.name.trim() === '') return 'Indica o teu nome.';
  if (!validatePhone(form.phone).valid) {
    return 'Indica um número de telemóvel válido: só algarismos, espaços e os sinais + ( ) -.';
  }
  if (!validatePasswordStrength(form.password).valid) {
    return `A palavra-passe não serve. ${PASSWORD_RULES}`;
  }
  if (form.password !== form.confirmPassword) return 'As palavras-passe não coincidem.';
  return null;
}

const FALLBACK = 'Não foi possível criar a conta. Tenta outra vez.';

/** Why the API refused a registration. */
export function registerErrorMessage(err: unknown): string {
  if (err instanceof ApiConflictError) return 'Já existe uma conta com este email.';
  if (!(err instanceof ApiRequestError)) {
    return 'Não foi possível chegar ao servidor. Verifica a ligação e tenta outra vez.';
  }

  if (err.status === 429) return 'Demasiadas tentativas. Espera um pouco e tenta outra vez.';
  if (err.status !== 400 && err.status !== 422) return FALLBACK;

  // A refusal names what it refused, and carries no code to go by.
  const said = err.message.toLowerCase();
  if (said.includes('captcha')) {
    return said.includes('expired')
      ? 'A verificação expirou. Faz de novo a verificação e tenta outra vez.'
      : 'Confirma que não és um robô.';
  }
  // "Email, password, and name are required" is about the name.
  if (said.includes('are required')) return 'Preenche o nome, o email e a palavra-passe.';
  if (said.includes('email address')) return 'O email não é válido.';
  if (said.includes('password')) return `A palavra-passe não serve. ${PASSWORD_RULES}`;
  if (said.includes('phone')) return 'Indica um número de telemóvel válido.';
  return FALLBACK;
}
